import React from 'react';
import { SIZE_SMALL } from '@eb/eds-button';
import { CheckChunky } from '@eb/eds-iconography';
import { Icon } from '@eb/eds-icon';

const CheckMark = ({ size, strokeColor }) => (
    <Icon type={<CheckChunky />} size={size} strokeColor={strokeColor} />
);

CheckMark.defaultProps = {
    size: SIZE_SMALL,
    strokeColor: 'ui-orange',
};

export default CheckMark;
